console.log('index.js')

// スクロール時の動き
window.onload = function() {

    console.log('window.onload')

    const wrapper = document.getElementById('js-wrapper');
    wrapper.classList.remove('wrapper-none');
    console.log('wrapper display')

    const headerLogo = document.getElementById('js-header-logo');
    const headerLogoText = document.getElementById('js-header-logo-text');

    const navigationMenu = document.getElementById('js-navigation-menu');

    const headerLogoSp = document.getElementById('js-header-logo-sp');
    const navigationSp = document.getElementById('js-navigationSp');
    const navigationSpButton = document.getElementById('js-navigationSp-button');
    const navigation = document.getElementsByClassName('js-navigation');
    const companyPage = document.getElementById('js-companyPage');
    console.log('companyPage', companyPage)

    const main = document.getElementsByClassName('main')[0];
    const mainRect = main.getBoundingClientRect();
    const mainY = window.pageYOffset + mainRect.top -300;

    if (companyPage) {
        console.log('aaaaaaa');
        headerLogo.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_brown.png"
        headerLogoText.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_text_brown.png"
        headerLogoSp.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_sp_brown.svg"
        headerLogoText.classList.add('logo-desplay');
        navigationMenu.classList.add('navigation_menu-white');
        navigationSpButton.classList.add('navigationSp_menuButton-black');
        navigationSpButton.classList.remove('navigationSp_menuButton-white');
        navigationSp.classList.add('wrapper_bg-black');
        navigationSp.classList.remove('fadeout');
    }
    if (!companyPage) {
        const wrapper = document.getElementsByClassName('wrapper');
        
        const concept = document.getElementsByClassName('concept')[0];
        const conceptRect = concept.getBoundingClientRect();
        const conceptY = window.pageYOffset + conceptRect.top -300;
        
        const service = document.getElementsByClassName('service')[0];
        const serviceRect = service.getBoundingClientRect();
        const serviceY = window.pageYOffset + serviceRect.top -300;
        
        const member = document.getElementsByClassName('member')[0];
        const memberRect = member.getBoundingClientRect();
        const memberY = window.pageYOffset + memberRect.top -300;
        
        const news = document.getElementsByClassName('news')[0];
        const newsRect = news.getBoundingClientRect();
        const newsY = window.pageYOffset + newsRect.top -900;
        
        window.addEventListener('scroll', function(){
            if (
                (document.documentElement.scrollTop > conceptY) &&
                (document.documentElement.scrollTop < serviceY)
            ) {
                // 背景を青に
                wrapper[0].classList.add('wrapper_bg-blue');
                wrapper[0].classList.remove('wrapper_bg-white');
                navigationSp.classList.add('wrapper_bg-blue');
                navigationSp.classList.remove('wrapper_bg-white');
                navigationSpButton.classList.add('navigationSp_menuButton-blue');
                navigationSpButton.classList.remove('navigationSp_menuButton-white');
                headerLogo.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_small_blue.svg"
                headerLogoSp.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_sp_blue.svg"
                navigationMenu.classList.add('navigation_menu-white');
            } else if (
                (document.documentElement.scrollTop > memberY) &&
                (document.documentElement.scrollTop < newsY)
            ) {
                // 背景を黒に
                wrapper[0].classList.add('wrapper_bg-black');
                wrapper[0].classList.remove('wrapper_bg-white');
                navigationSp.classList.add('wrapper_bg-black');
                navigationSp.classList.remove('wrapper_bg-white');
                navigationSpButton.classList.add('navigationSp_menuButton-black');
                navigationSpButton.classList.remove('navigationSp_menuButton-white');
                headerLogo.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_brown.png"
                headerLogoSp.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_sp_brown.svg"
                navigationMenu.classList.add('navigation_menu-white');
            } else {
                // 背景を白に
                wrapper[0].classList.add('wrapper_bg-white');
                wrapper[0].classList.remove('wrapper_bg-blue');
                wrapper[0].classList.remove('wrapper_bg-black');
                navigationSpButton.classList.add('navigationSp_menuButton-white');
                navigationSpButton.classList.remove('navigationSp_menuButton-blue');
                navigationSpButton.classList.remove('navigationSp_menuButton-black');
                navigationSp.classList.add('wrapper_bg-white');
                navigationSp.classList.remove('wrapper_bg-blue');
                navigationSp.classList.remove('wrapper_bg-black');
                headerLogo.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_small.png"
                headerLogoSp.src = "//cdn.shopify.com/s/files/1/0662/0384/4822/t/1/assets/header_logo_sp.svg"
                navigationMenu.classList.remove('navigation_menu-white');
            }
        });
    }


    window.addEventListener('scroll', function(){
        if (document.documentElement.scrollTop > mainY) {
            // トップ以外
            console.log('aaaa');
            headerLogoText.classList.add('fadeout');
            headerLogoText.classList.remove('fadein-normal');

            headerLogo.classList.remove('navigation_logo-small');
            headerLogo.classList.add('navigation_logo-big');
        } else {
            // トップ
            console.log('bbb');
            headerLogoText.classList.add('fadein-normal');
            headerLogoText.classList.remove('fadeout');

            headerLogo.classList.remove('navigation_logo-big');
            headerLogo.classList.add('navigation_logo-small');
        }
    });
};
